/* Heirloom widget analytics (lightweight).
 * - GA4 events via the page gtag installed by the Google & YouTube app: em_widget_view / em_widget_click.
 * - Order attribution: cross-sell clicks are remembered for 30 min; adding the promoted product to cart from its
 *   product page stamps the line with hidden property _em_source (visible on the order in Shopify admin).
 * Widgets opt in with data-em-widget="<type>" data-em-widget-id="<id>" [data-em-target="<handle|pack>"].
 */
(() => {
  if (window.__emAnalytics) return;
  window.__emAnalytics = true;

  const GA4_ID = 'G-QEDMTZN9KQ';
  const SRC_KEY = 'em_widget_source';
  const SRC_TTL_MS = 30 * 60 * 1000;
  const seen = new Set();

  const pageProduct = () => {
    const m = window.location.pathname.match(/\/products\/([^/?#]+)/);
    return m ? decodeURIComponent(m[1]) : '';
  };

  const params = (el) => ({
    widget_type: el.dataset.emWidget || '',
    widget_id: el.dataset.emWidgetId || '',
    widget_target: el.dataset.emTarget || '',
    page_product: pageProduct(),
    page_type: (window.ShopifyAnalytics && window.ShopifyAnalytics.meta && window.ShopifyAnalytics.meta.page && window.ShopifyAnalytics.meta.page.pageType) || '',
  });

  const send = (name, data) => {
    try {
      if (typeof window.gtag === 'function') window.gtag('event', name, { ...data, send_to: GA4_ID });
    } catch (e) {}
    try {
      if (window.Shopify && window.Shopify.analytics && window.Shopify.analytics.publish) window.Shopify.analytics.publish(name, data);
    } catch (e) {}
  };
  window.emTrack = send;

  // Views: once per widget id + target per page view, when at least half visible.
  const io = 'IntersectionObserver' in window
    ? new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          const el = entry.target;
          io.unobserve(el);
          const p = params(el);
          const key = `${p.widget_id}|${p.widget_target}`;
          if (seen.has(key)) return;
          seen.add(key);
          send('em_widget_view', p);
        });
      }, { threshold: 0.5 })
    : null;

  const scan = (root) => {
    if (!io) return;
    (root.querySelectorAll ? root.querySelectorAll('[data-em-widget]') : []).forEach((el) => {
      if (el.__emObserved) return;
      el.__emObserved = true;
      io.observe(el);
    });
  };
  scan(document);
  new MutationObserver((muts) => muts.forEach((m) => m.addedNodes.forEach((n) => n.nodeType === 1 && (n.matches && n.matches('[data-em-widget]') ? scan(n.parentElement || document) : scan(n))))).observe(document.documentElement, { childList: true, subtree: true });

  // Clicks (capture phase so it fires before navigation / cart swaps).
  document.addEventListener('click', (event) => {
    const el = event.target.closest && event.target.closest('[data-em-widget]');
    if (!el) return;
    const p = params(el);
    send('em_widget_click', p);
    if (p.widget_type === 'xsell' && p.widget_target) {
      try {
        sessionStorage.setItem(SRC_KEY, JSON.stringify({ source: p.widget_id, handle: p.widget_target, t: Date.now() }));
      } catch (e) {}
    }
  }, true);

  // Navigation clicks (header menu + mobile drawer): em_menu_click {menu_item, menu_url, menu_location}.
  document.addEventListener('click', (event) => {
    const link = event.target.closest && event.target.closest('a[href]');
    if (!link || link.closest('[data-em-widget]')) return;
    const drawer = link.closest('.menu-drawer, header-drawer, [class*="menu-drawer"]');
    const header = link.closest('header, .header, [id$="__h1_header"]');
    if (!drawer && !header) return;
    if (!(link.closest('nav, .menu-list, .menu-drawer__menu, [class*="menu"]'))) return;
    send('em_menu_click', {
      menu_item: (link.textContent || '').replace(/\s+/g, ' ').trim().slice(0, 80),
      menu_url: link.getAttribute('href') || '',
      menu_location: drawer ? 'mobile_drawer' : 'header',
      page_type: (window.ShopifyAnalytics && window.ShopifyAnalytics.meta && window.ShopifyAnalytics.meta.page && window.ShopifyAnalytics.meta.page.pageType) || '',
    });
  }, true);

  // Attribution: stamp product forms on the promoted product's page.
  const stamp = () => {
    let src;
    try { src = JSON.parse(sessionStorage.getItem(SRC_KEY) || 'null'); } catch (e) { src = null; }
    if (!src || src.handle !== pageProduct() || Date.now() - src.t > SRC_TTL_MS) return;
    document.querySelectorAll('form[action*="/cart/add"]').forEach((form) => {
      if (form.querySelector('input[name="properties[_em_source]"]')) return;
      const input = document.createElement('input');
      input.type = 'hidden';
      input.name = 'properties[_em_source]';
      input.value = src.source;
      form.appendChild(input);
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', stamp); else stamp();
})();
